import React, { useState } from "react";
import Layout from "../Componants/Layout";
import { Col, Container, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import ProgressBar from "react-bootstrap/ProgressBar";
import { Link, useNavigate } from "react-router-dom";
import Form from "react-bootstrap/Form";
import { useMutation, useQuery } from "@tanstack/react-query";
import { getRequest, putRequest } from "../services/apiMethods";
import { formatAndTruncateText, getTheDays, truncateText } from "../utils/HelperFunctions";
import SearchBarComp from "../Componants/SearchBarComp";
import toast from "react-hot-toast";
import GiveReviewModal from "../Modal/GiveReviewModal";

export default function YourEnquiries() {
  const [searchValue, setSearchValue] = useState('');
  const Navigate = useNavigate();
  const [review, setReview] = useState(false)
  const [checkStatus, setCheckStatus] = useState("")
  const [leadID, setLeadID] = useState("")

  
  const handleReviewClose = () => {
    setReview(false)
    setLeadID("")
  }
  const handleReviewOpen = () => {
    setReview(true)
  }
  // Fetch data from API
  const { data: enquiriesList, error: enquiriesError, isLoading: enquiriesLodaing ,refetch } = useQuery({
    queryKey: ["enquiriesList" ,searchValue],
    queryFn: () => getRequest(`/lead/list?search=${searchValue}`),
    enabled: searchValue !== null, 
  });

  const { mutate: updateEnquiriesStatus } = useMutation({
    mutationFn: (data) => {
      return putRequest("/lead/status", data);
    },
    onSuccess: (data) => {
      if (checkStatus == "Work Complete") {
        handleReviewOpen()
      } else {
        toast.success(`${data?.message}`, {
          iconTheme: {
            primary: '#337FE0',
            secondary: '#FFFAEE',
          },
        })
        refetch()
      }
      setCheckStatus("")
    },
    onError: (error) => {
      console.error("Error during API call:", error);
      setCheckStatus("")
    },
  });


  const handleUpdateStatus = (id, status ,leadID) => {
    if (status == "Work Complete") {
      setCheckStatus(status)
      setLeadID(leadID)
    }
    const payload = {
      leadId: id,
      status: status
    };
    updateEnquiriesStatus(payload);
  }


  const tooltip = (
    <Tooltip id="tooltip" >
      <div className="tool-desc">
      Once the work is marked as “Complete” and a review has been submitted, the enquiry status is locked.
      This ensures that the job can’t be changed to “Enquired,” “Didn’t Hire Anyone,” or “Hired Someone Else” after completion. No further reviews can be added once the status is finalised
      </div>
    </Tooltip>
  );



  return (
    <>
      <Layout>
        <Container>
          <div className="dashboard-main">
            <h3>
            Your Enquiries{" "}
                  (<span>
                    {Array.isArray(enquiriesList?.data) &&
                      enquiriesList?.data?.length}
                  </span>)
                  <OverlayTrigger placement="right"   overlay={tooltip}>
                    <span className="m-1">
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.25 12C1.25 17.9371 6.06294 22.75 12 22.75C17.9371 22.75 22.75 17.9371 22.75 12C22.75 6.06294 17.9371 1.25 12 1.25C6.06294 1.25 1.25 6.06294 1.25 12ZM11.6819 11.0273C11.9289 11.0605 12.2707 11.1494 12.5607 11.4394C12.8507 11.7294 12.9396 12.0711 12.9728 12.3182C13.0003 12.5228 13.0001 12.7608 13 12.9606V13V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V13C10.4477 13 10 12.5523 10 12C10 11.4477 10.4477 11 11 11H11.0394C11.2393 10.9999 11.4772 10.9997 11.6819 11.0273ZM11.9954 7C11.4456 7 10.9999 7.44772 10.9999 8C10.9999 8.55228 11.4456 9 11.9954 9H12.0044C12.5542 9 12.9999 8.55228 12.9999 8C12.9999 7.44772 12.5542 7 12.0044 7H11.9954Z" fill="black" />
                      </svg>
                    </span>
                  </OverlayTrigger>
                </h3>


            <p>Here’s all of your enquiries</p>
            <div className="enquiries-search stepper-content">
              <Form className="cmn-form-set">
                <Form.Group className="mb-3" controlId="formBasicEmail">
                <SearchBarComp setSearchValue={setSearchValue} />
                </Form.Group>
              </Form>
            </div>
            <Row className="mt-4 enquiries-sec">
              {Array.isArray(enquiriesList?.data) && enquiriesList?.data.length > 0 ? (
                enquiriesList?.data.map((ele, index) => (
                  <Col lg={4} key={index} className="display-table mb-3">
                    <div className="leads-pending-card table-cell">
                      <div className="leads-pending-pro">
                        <div className="pending-pro-view cursor-pointer"  onClick={()=>Navigate(`/enquiry-detail/${ele?._id}`)}>
                          <div>
                            <h3>{ele?.service?.serviceName}</h3>
                            <p>{ele?.category?.categoryName}</p>
                            {ele?.city ? <p>{truncateText(ele?.city, 6)}</p> : <p>{formatAndTruncateText(ele?.address, 6)}</p>}
                          </div>
                        </div>
                        <span className="update-enquiry" >
                                            <Form.Select aria-label="Default select example"
                                            value={ele?.status}
                                            disabled={ele?.status === "Work Complete"}
                                            onChange={(e) => handleUpdateStatus(ele?._id, e.target.value, ele?._id)}
                                            className="update-enquiry-status-dashboard">
                                                <option value="Enquired">Enquired</option>
                                                <option value="Work Complete">Work Complete</option>
                                                <option value="Didn’t hire anyone">Didn’t hire anyone</option>
                                              </Form.Select>
                          </span>
                      </div>

                      <div className="pending-pro-quote mt-4">
                        <p>You have {ele?.response} responses from our members</p>
                      </div>
                      {/* <span className="active-shape">
                        <svg xmlns="http://www.w3.org/2000/svg" width="45" height="45" viewBox="0 0 45 45" fill="none">
                          <path d="M0 15C0 6.71573 6.71573 0 15 0H45L22.5 22.5L0 45V15Z" fill="#337FE0" />
                        </svg>
                      </span> */}
                    </div>
                  </Col>
                ))
              ) : (
                <div>No Data Found</div>
              )}

            </Row>
          </div>
        </Container>

        <GiveReviewModal
        review={review}
        handleReviewClose={handleReviewClose}
        leadID={leadID}
      />
      </Layout>
    </>
  );
}
